import { withTranslation, Trans } from "react-i18next";
import i18n from "i18next";
import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Breadcrumbs, BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Breadcrumb as BootstrapBreadcrumb } from "react-bootstrap";
import CrumbItem from "../Shared/Breadcrumb/crumb-item";
import { getAppNavigation } from "../../Actions";
import AppWrapper from "../Shared/AppWrapper";
import Header from "./Header";
import Loading from "./loading";
import UserMessage from "../Shared/Messages";
import Routes from "./routes";
import ModalRoot from "../Shared/ModalPopup";

import ErrorBoundary from "../Shared/ErrorBoundary"
import { WorkshopLogin } from "../../Constants"
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    if (!this.props.isAuthenticated) {
      this.props.dispatch(getAppNavigation(this.props.match.params.ssoid));
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (this.props.security && this.props.security.isEnabled === "N") { window.location.href = WorkshopLogin }
    }

  }

  render() {
    const { userDefault, isAuthenticated } = this.props;
    return <ErrorBoundary> {

      !isAuthenticated ? (
        <Wrapper />
      ) : (

          <AppWrapper {...this.props}>
            <Wrapper>
              <Header {...this.props} />
              <ErrorBoundary>
                {userDefault && i18n.languages && (
                  <>
                    <Breadcrumbs
                      item={CrumbItem}
                      separator={<b />}
                      container={BootstrapBreadcrumb}
                      finalProps={{ active: true }}
                      duplicateProps={{ to: "href" }}
                    />
                    {this.props.userDefault.defaultProfile.emplRole ===
                      "Workshop Manager" ||
                      this.props.userDefault.defaultProfile.emplRole ===
                      "Workshop Admin" ? (
                        this.props.userDefault.defaultProfile.isMaintScehduling === "Y" ? (
                          <BreadcrumbsItem to="/scheduling">
                            <Trans>workshop</Trans>
                          </BreadcrumbsItem>
                        ) : (
                          <BreadcrumbsItem to="/workshop">
                            <Trans>workshop</Trans>
                          </BreadcrumbsItem>
                        )
                      ) : (
                        <BreadcrumbsItem to="/workshopTechnician">
                          <Trans>workshop</Trans>
                        </BreadcrumbsItem>
                      )}
                    {this.props.userDefault.defaultProfile.emplRole ===
                      "Workshop Manager" ||
                      this.props.userDefault.defaultProfile.emplRole ===
                      "Workshop Admin" ? (
                        <BreadcrumbsItem
                          glyph
                          to={
                            "/timetracking/" + this.props.user.empId + "/manager/home"
                          }
                        >
                          <Trans>timeTrack</Trans>
                        </BreadcrumbsItem>
                      ) : (
                        <BreadcrumbsItem
                          glyph
                          to={
                            "/timetracking/" +
                            this.props.user.empId +
                            "/technician/monthview"
                          }
                        >
                          <Trans>timeTrack</Trans>
                        </BreadcrumbsItem>
                      )}
                  </>
                )}
                {userDefault && (
                  <Routes
                    {...this.props}
                    {...this.props.userDefault.defaultProfile}
                  />
                )}
              </ErrorBoundary>
              <Loading />
              <UserMessage />
              <ModalRoot />
            </Wrapper>

          </AppWrapper>
        )
    }</ErrorBoundary>
  }
}

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const mapStateToProps = ({ auth, fetchTimesheetSecurity }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    user: auth.appData,
    userDefault: auth.user,
    security: fetchTimesheetSecurity.securityList
  };
};

export default connect(mapStateToProps)(withTranslation()(App));
